import React from "react";

const HomeBanner = () => {
  return (
    <div className="home-banner">
      <div className="banner-content">
        {/* <div> <span style={{ color: "#e8d70c" }}>WATCH NOW</span> - As a thank you to their fans</div> */}
        <div style={{ textAlign: "center" }}>
         {" "}
        </div>
        <div>Dave Matthews Band invites you to a free live broadcast from the Freedom Mortgage Pavilion in Camden, NJ, </div>
        <div>
        on Saturday July 20, 2024 at 7:30PM EDT. Please click the ‘GET ACCESS’ button below to register for free access!
        </div>
        <div>
        If you see a ‘JOIN THE CROWD’ button, you are already registered. Just click the button at showtime and we will see you there!
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
